import {call, put} from "redux-saga/effects";

import {requestGetRemoteConfig, requestUpdateRemoteConfig} from "../requests/remoteConfigService";
import {setError, setLoading, setProcessing, setRemoteConfig} from "../../slices/remoteConfigSlice";
import {toast} from "react-toastify";

function* handleGetRemoteConfig() {
  try {
    yield put(setLoading())
    const response = yield call(() => requestGetRemoteConfig())
    yield put(setRemoteConfig(response.data))
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    yield put(setError(errMsg))
  }
}

function* handleUpdateRemoteConfig(action) {
  const {configType, configPayload} = action.payload
  try {
    yield put(setProcessing())
    const response = yield call(() => requestUpdateRemoteConfig(configPayload))
    yield put(setRemoteConfig({...response.data}))
    toast.success(`${configType} updated successfully!`)
  } catch (error) {
    const errMsg = error.response ? error.response.data.message : error.message;
    toast.error(errMsg)
    yield put(setProcessing(false))
  }
}


export {handleGetRemoteConfig, handleUpdateRemoteConfig}